angular.module('unica_event.event_controllers')

.controller('EventListController', function(
	$rootScope, $scope, $state, $stateParams,
	$confirm, EventCreateService,
	EventListService, EventDeleteService, EventEditService,
	ArchiveEventEditService
) {
	$scope.eventList = [];
	$scope.limit  = 10;
	$scope.offset = 0;
	$scope.canLoad = true;

	$scope.updateStateYear();

	$scope.loadEvents = function() {
		$scope.showLoader();
		$scope.canLoad = false;
		EventListService.list($scope.limit, $scope.offset, $rootScope.year)
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					data = $rootScope.parseStages( data );

					$scope.eventList = $scope.eventList.concat( data );
					if ( data.length === 0 || data.length < $scope.limit ) {
						$scope.canLoad = false;
					} else {
						$scope.canLoad = true;
						$scope.offset = $scope.offset + data.length;
					}
				}
			});
	};

	$scope.loadEvents();

	$scope.toggleEventSubRow = function(eventId) {
		angular.forEach($scope.eventList, function(ev, key) {
			if ( ev.id == eventId ) {
				ev.subrow = !ev.subrow;
				$scope.eventList[key] = ev;
			}
		});
	};

	$scope.asyncSelected = undefined;
	$scope.ibNoResults = false;
	$scope.loadingEvents = false;

	// $scope.resetEventList = function() {
	// 	$scope.asyncSelected = undefined;
	//
	// 	$scope.eventList = [];
	// 	$scope.limit  = 10;
	// 	$scope.offset = 0;
	// 	$scope.canLoad = true;
	//
	// 	$scope.loadEvents();
	// }

	$scope.$watch('asyncSelected', function() {
		if ( $scope.asyncSelected !== undefined && $scope.asyncSelected.length == 0 ) {
			$scope.canLoad = true;
			$scope.offset = 0;
			$scope.eventList = [];
			$scope.loadEvents();
		}
	});

	$scope.searchEvent = function(search) {
		$scope.loadingEvents = true;

		console.log('searching..');

		EventListService
			.searchByYear($rootScope.year, search)
			.then(function(data) {
				$scope.loadingEvents = false;
				$scope.canLoad = false;
				if ( data.length > 0 ) {
					data = $rootScope.parseStages( data );

					$scope.ibNoResults = false;
					$scope.eventList = data;
					return data;
				} else {
					$scope.eventList = [];
					$scope.ibNoResults = true;
					return null;
				}
			});
	};

	$scope.archiveEvent = function(eventId) {

		$confirm({
			title: 'Sei sicuro di voler archiviare l\'evento?',
			text: 'Confermi l\'archiviazione dell\'evento?'
		}).then(function() {

			$scope.showLoader();
			EventEditService.archive( eventId  )
				.then(function(data) {
					$scope.hideLoader();

					if (data && !data.error) {
						angular.forEach($scope.eventList, function(event, key) {
							if ( event.id == eventId ) {
								$scope.eventList[key].archived = 1;
							}
						});
						$scope.showSuccessMsg('Evento archiviato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

	$scope.restoreEvent = function(eventId) {

		$confirm({
			title: 'Sei sicuro di voler rimovere l\'evento dall\'archivio?',
			text: 'Confermi l\'operazione sull\'evento?'
		}).then(function() {

			$scope.showLoader();
			ArchiveEventEditService
				.restore( eventId  )
				.then(function(data) {
					$scope.hideLoader();

					if (data && !data.error) {
						angular.forEach($scope.eventList, function(event, key) {
							if ( event.id == eventId ) {
								$scope.eventList[key].archived = 0;
							}
						});
						$scope.showSuccessMsg('Evento ripristinato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};

	$scope.cloneEvent = function(eventId) {

		$confirm({
			title: 'Sei sicuro di voler duplicare l\'evento?',
			text: 'Confermi la duplicazione dell\'evento?'
		}).then(function() {

			$scope.showLoader();
			EventCreateService.clone( eventId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						$state.go('app.event.edit', { year: $rootScope.year, id: data.id });

						$scope.showSuccessMsg('Evento duplicato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});
	};

	$scope.deleteEvent = function(eventId) {

		$confirm({
			title: 'Sei sicuro di voler eliminare l\'evento?',
			text: 'Confermi la cancellazione dell\'evento?'
		}).then(function() {

			$scope.showLoader();
			EventDeleteService.delete( eventId  )
				.then(function(data) {
					$scope.hideLoader();

					if (!data.error) {
						angular.forEach($scope.eventList, function(event, key) {
							if ( event.id == eventId ) {
								$scope.eventList.splice(key, 1);
							}
						});
						$scope.showSuccessMsg('Evento eliminato con successo!', '');
					} else {
						$rootScope.manageError(data);
					}

				});

		}, function() {
			// Cancel
		});

	};



})

;